import PropTypes from "prop-types";
import React from "react";
import { Badge } from "@yoast/ui-library";

const VARIANT_BY_STATUS = {
	active: "success",
	"pending-cancel": "info",
	"on-hold": "info",
	cancelled: "error",
	expired: "error",
	refunded: "error",
};

/**
 * The status of a provisioned subscription as a badge.
 *
 * @param {Object} props Component props.
 *
 * @returns {JSX.Element} The badge.
 */
function ProvisionedSubscriptionStatusBadge( { status = null } ) {
	const normalized = ( status || "" ).toLowerCase();

	return (
		<Badge variant={ VARIANT_BY_STATUS[ normalized ] || "plain" } size="small">
			{ status || "—" }
		</Badge>
	);
}

ProvisionedSubscriptionStatusBadge.propTypes = {
	status: PropTypes.string,
};

export default ProvisionedSubscriptionStatusBadge;
